const QueryHelper = {
  install(Vue, router) {
    const vue = Vue;
    if (this.installed) {
      return;
    }
    this.installed = true;

    vue.prototype.$queryHelper = {
      get({ validSort } = {}) {
        const query = {};

        if (typeof router.currentRoute.query.page !== 'undefined') {
          if (/^-?\d+$/.test(router.currentRoute.query.page)) {
            query.page = parseInt(router.currentRoute.query.page, 10);
          }
        }

        if (typeof router.currentRoute.query.direction !== 'undefined') {
          if (['desc', 'asc'].includes(router.currentRoute.query.direction)) {
            query.direction = router.currentRoute.query.direction;
          }
        }

        if (typeof router.currentRoute.query.sort !== 'undefined') {
          if (validSort.includes(router.currentRoute.query.sort)) {
            query.sort = router.currentRoute.query.sort;
          }
        }

        return query;
      },
    };
  },
};

export default QueryHelper;
